import React, {useMemo} from "react";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import NotificationsToggler from './topbar/NotificationsToggler';
import ChatMessagesToggler from './topbar/ChatMessagesToggler';
import CollaborateMessagesToggler from './topbar/CollaborateMessagesToggler';
import {toAbsoluteUrl} from "../../../_helpers";
import {useHtmlClassService} from "../../core/AppLayout";
import {QuickUserToggler} from "../extras/QuickUserToggler";
import {SettingsPanelToggler} from "../settings-panel/SettingsPanelToggler";

export function Topbar() {
    const uiService = useHtmlClassService();

    const layoutProps = useMemo(() => {
        return {
            viewQuickPanelDisplay: objectPath.get(
                uiService.config,
                "extras.quick-panel.display"
            ),
            viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
        };
    }, [uiService]);

    return (
        <div className="topbar">
            <SettingsPanelToggler/>

            {layoutProps.viewQuickPanelDisplay && (
                <div className="topbar-item">
                    <div className="btn btn-icon btn-topbar btn-lg mr-1" id="od_quick_panel_toggle">
                        <span className="svg-icon svg-icon-xl svg-icon-white">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-4-blocks.svg")}/>
                        </span>
                    </div>
                </div>
            )}

            <NotificationsToggler/>

            <ChatMessagesToggler/>

            <CollaborateMessagesToggler/>

            <div className="topbar-item">
                <div className="btn btn-icon btn-topbar btn-lg mr-1"
                     id="od_quick_panel_toggle">
                    <span className="svg-icon svg-icon-xl svg-icon-white">
                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Clipboard.svg")}/>
                    </span>
                </div>
            </div>

            {layoutProps.viewUserDisplay && <QuickUserToggler/>}
        </div>
    );
}
